import lodash from 'lodash'
import { getBuildingInfoById } from '@/api/buildings/request'
import { SITE_TYPE } from '@/constants/modeltypes'

export function checkMultiSites (building) {
  const multiPhysicalSites = building.sites.filter(site => site.type === SITE_TYPE.PHYSICAL)
  const invalidSites = multiPhysicalSites.map(item => item.code)
  if (invalidSites.length > 1) console.warn('There are %s physical sites(%s) bind with %s building', invalidSites.length, invalidSites.join(','), building.code)
}

export function getPhysicalSite (sites) {
  let result = sites.filter(site => site.type === SITE_TYPE.PHYSICAL)
  if (result.length === 1) {
    return result[0]
  } else if (result.length > 1) {
    const siteInfo = result.map(item => (`${item.code}(id: ${item.id})`)).join(',')
    throw new Error(`'There are ${result.length} physical sites(${siteInfo}) bind with your building'`)
  } else {
    console.warn('Your building does not have any physical site')
    return {}
  }
}

export async function setPhysicalSite (buildingId, item) {
  let result = null
  if (buildingId) {
    result = await getBuildingInfoById(buildingId)
  }
  if (result) {
    const physicalSite = getPhysicalSite(result.sites)
    lodash.set(item, 'physicalSite', physicalSite)
  }
  return item
}
